import React, { Component } from "react";
import TopBar from "../menus/TopBar";
import ExploreWorkBar from "../menus/ExploreWorkBar";

class Contact extends Component {
  render() {
    return (
      <div className="flex-contain-page">
        <div className="light-border">
          <div className="red-background">
            <div className="about-contact-max-width">
              <TopBar variant="red" />
              <div className="main-content">
                <div>
                  <h3>Get in touch</h3>
                  <h4>
                    I’m always open to connecting and exploring collaborations.
                  </h4>
                  <br />
                  <p className="p2">
                    I also create bespoke pieces inspired by music. If you’d
                    like a visual art piece based on a song that’s special to
                    you, feel free to reach out.
                  </p>
                  <div className="contact-flex-container">
                    <p className="p2-bold">
                      Email: <br />
                      Instagram:
                    </p>
                    <p className="p2-bold">
                      <a
                        href="mailto:jadelawstudio@gmail.com"
                        className="p2-link"
                      >
                        jadelawstudio@gmail.com
                      </a>
                      <br />
                      <a
                        href="https://www.instagram.com/art.by.jade.law/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p2-link"
                      >
                        @art.by.jade.law
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ExploreWorkBar />
      </div>
    );
  }
}

export default Contact;
